module.exports = __webpack_public_path__ + "static/CircularStd-MediumItalic-bec302349ab7c9cfbb3cb2b9892dbfcb.woff2";